export const presets = {
  'RB Agent': [
    'CREATE_ZENDESK_TICKET',
    'IMAGE',
    'LISTINGS',
    'POSTING',
    'PROMOTIONS',
    'SUPPORT',
    'TEXT',
    'UPLOAD_DOCS',
    'VEHICLES',
  ],
  'RB Manager': [
    'CREATE_ZENDESK_TICKET',
    'IMAGE',
    'INSURANCE_POLICY',
    'LISTINGS',
    'MESSAGING',
    'POSTING',
    'PROMOTIONS',
    'REFIS',
    'REFI_PHONE',
    'REGISTRATION',
    'SUPPORT',
    'TASKS',
    'TEXT',
    'TRANSACTIONS',
    'UPLOAD_DOCS',
    'VEHICLES',
    'VIEW_DOCS',
  ],
  'Blinker agent': [
    'CALL_CENTER_AGENT',
    'CREATE_ZENDESK_TICKET',
    'CONTINUE_AS_CUSTOMER',
    'IMAGE',
    'INSURANCE_POLICY',
    'LISTINGS',
    'LOSS_PAYEE',
    'MESSAGING',
    'POSTING',
    'PROMOTIONS',
    'PROOF_OF_EMPLOYMENT',
    'PROOF_OF_INSURANCE',
    'PROOF_OF_RESIDENCE',
    'RECEIVE_APP_FOR_TITLE',
    'RECEIVE_LPOA',
    'RECEIVE_SPOA',
    'REFIS',
    'REFI_PHONE',
    'REGISTRATION',
    'REVIEW_BACKGROUND_ERROR',
    'REVIEW_FOR_FRAUD',
    'REVIEW_OFAC',
    'REVIEW_PLAID_DATA_MISMATCH',
    'REVIEW_STATEMENT',
    'REVIEW_USER_DATA_MISMATCH',
    'SEND_BUYER_PACKET',
    'SEND_FUNDS_TO_LIENHOLDER',
    'SEND_SPOA_TO_SELLER',
    'SIGN_LOAN_AGREEMENT',
    'SSN_CARD',
    'SUBMIT_PROOF_OF_INCOME',
    'SUPPORT',
    'TASKS',
    'TEXT',
    'TITLE',
    'TRADEINS',
    'TRANSACTIONS',
    'UNDERWRITING',
    'UPDATE_LIENHOLDER_INFO',
    'UPLOAD_DOCS',
    'VEHICLES',
    'VERIFY_FUNDS',
    'VERIFY_MILEAGE',
    'VIEW_DOCS',
  ],
  FCA: [
    'CARFAX_FRAUD_REVIEW',
    'CONTACT_LIENHOLDER',
    'CURRENT_MORTGAGE_STATEMENT',
    'DRIVER_LICENSE',
    'FRAUD',
    'FUNDING',
    'IMAGE',
    'INSURANCE_POLICY',
    'LOSS_PAYEE',
    'PROOF_OF_EMPLOYMENT',
    'PROOF_OF_INSURANCE',
    'PROOF_OF_RESIDENCE',
    'REFIS',
    'REVIEW_FOR_FRAUD',
    'REVIEW_OFAC',
    'REVIEW_STATEMENT',
    'SEND_FUNDS_TO_LIENHOLDER',
    'SIGN_LOAN_AGREEMENT',
    'SSN_CARD',
    'SUBMIT_PROOF_OF_INCOME',
    'TASKS',
    'TRANSACTIONS',
    'UNDERWRITING',
    'UPDATE_LIENHOLDER_INFO',
    'UPLOAD_DOCS',
    'VEHICLES',
    'VERIFY_MILEAGE',
    'VIEW_DOCS',
  ],
  'Site Admin': [
    'ADMIN',
    'ADMIN_WEB',
    'ANALYTICS',
    'APP_FOR_TITLE',
    'CALL_CENTER_AGENT',
    'CARFAX_FRAUD_REVIEW',
    'CONTACT_LIENHOLDER',
    'CONTINUE_AS_CUSTOMER',
    'CREATE_ZENDESK_TICKET',
    'CURRENT_MORTGAGE_STATEMENT',
    'DRIVER_LICENSE',
    'EDIT_USER',
    'FINAL_LOAN',
    'FRAUD',
    'FUNDING',
    'HANDLE_INSUFFICIENT_FUNDS',
    'HANDLE_TITLE',
    'IMAGE',
    'INSURANCE_POLICY',
    'LISTINGS',
    'LOSS_PAYEE',
    'MESSAGING',
    'POSTING',
    'PROMOTIONS',
    'PROOF_OF_EMPLOYMENT',
    'PROOF_OF_INSURANCE',
    'PROOF_OF_RESIDENCE',
    'RECEIVE_APP_FOR_TITLE',
    'RECEIVE_LPOA',
    'RECEIVE_SPOA',
    'REFIS',
    'REFI_PHONE',
    'REGISTRATION',
    'REVIEW_BACKGROUND_ERROR',
    'REVIEW_FOR_FRAUD',
    'REVIEW_OFAC',
    'REVIEW_PLAID_DATA_MISMATCH',
    'REVIEW_STATEMENT',
    'REVIEW_USER_DATA_MISMATCH',
    'SEND_BUYER_PACKET',
    'SEND_FUNDS_TO_LIENHOLDER',
    'SEND_SPOA_TO_SELLER',
    'SIGN_LOAN_AGREEMENT',
    'SSN_CARD',
    'SUBMIT_PROOF_OF_INCOME',
    'SUPERUSER',
    'SUPPORT',
    'SUSPEND_USER',
    'TASKS',
    'TEXT',
    'TITLE',
    'TRADEINS',
    'TRANSACTIONS',
    'UNDERWRITING',
    'UPDATE_LIENHOLDER_INFO',
    'UPLOAD_DOCS',
    'USERS',
    'VEHICLES',
    'VERIFY_FUNDS',
    'VERIFY_MILEAGE',
    'VIEW_DOCS',
  ],
}
